export const ADD_LANGUAGE = "/exam/questions";
export const GET_QUESTION = "/exam/questions/";
export const SAVE_QUESTION = "/exam/questions";
export const SUBMIT_EXAM = "/exam/submit";
export const GET_RESULT = "/exam/result/";
export const UPDATE_TIME = "/exam/time";
export const UPDATE_FEEDBACK = "/exam/feedback";
